/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popEvents.vue?vue&type=template&id=62009815&scoped=true"
import script from "./popEvents.vue?vue&type=script&lang=js"
export * from "./popEvents.vue?vue&type=script&lang=js"
import style0 from "./popEvents.vue?vue&type=style&index=0&id=62009815&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62009815",
  null
  
)

export default component.exports